// Created to only provide Merchant MetaData
// For Product Specific Merchant checks and Feature Toggles, use MerchantProvider
import React, { useContext, useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { getMerchantConfig } from '../services/pgConfig';
import { getRequestUrlAndToken, logout } from '../utils/common';

import { AuthContext } from '../contexts/AuthContext';
import { MerchantDetailsContext } from '../contexts/MerchantDetailsContext';

// Need to export as components, apart from default for supporting Module Federation
export const MerchantDetailsProvider = ({ children }) => {
  const [isMerchantDetailsFetched, setMerchantDetailsFetched] = useState(false);
  const [merchantDetails, setMerchantDetails] = useState({});

  const authObj = useContext(AuthContext);
  const { env, userObj } = authObj || {};
  // get merchantToken or gammaToken or token (in case of partners).
  const { token } = getRequestUrlAndToken();

  const populateMerchantDetails = merchantDetailsResponse => {
    setMerchantDetails(merchantDetailsResponse);
    setMerchantDetailsFetched(true);
  };

  const getMerchantDetails = async () => {
    if (userObj && userObj.cfToken && userObj.cfToken[env]) {
      const tokenVal = token || userObj.cfToken[env].token;

      const response = await getMerchantConfig(tokenVal);
      await populateMerchantDetails(response);
    } else if (window.location.hostname !== 'localhost') {
      logout();
    } else {
      userObj.logout();
    }
  };

  useEffect(() => {
    if (!isMerchantDetailsFetched) {
      getMerchantDetails();
    }
  }, [isMerchantDetailsFetched]);

  const value = useMemo(
    () => ({
      isMerchantDetailsFetched,
      merchantDetails,
      populateMerchantDetails,
    }),
    [isMerchantDetailsFetched, merchantDetails],
  );

  return (
    <MerchantDetailsContext.Provider value={value}>
      {children}
    </MerchantDetailsContext.Provider>
  );
};

export default MerchantDetailsProvider;

MerchantDetailsProvider.propTypes = {
  children: PropTypes.any,
};
